import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from '../../layout/AdminDashboardLayout/DashboardLayout';
import DashboardHome from '../../screens/admin/AdminDashboard/DashboardHome';
import AdminUserManagement from '../../screens/admin/AdminUserManagement/AdminUserManagement';
import AdminDetailScreen from '../../screens/admin/AdminUserManagement/AdminDetailScreen';
import PackageManagementt from '../../screens/admin/AdminPackagesManagement/PackageManagementt';
import PackageDashboard from '../../subscreens/admin/AdminPackageManagement/PackageDashboard';
import PackageList from '../../subscreens/admin/AdminPackageManagement/PackageList';
import PackageBookings from '../../subscreens/admin/AdminPackageManagement/PackageBookings';
import PackageRevenue from '../../subscreens/admin/AdminPackageManagement/PackageRevenue';
import PackageAnalytics from '../../subscreens/admin/AdminPackageManagement/PackageAnalytics';
import AdminNotifications from '../../screens/admin/AdminNotifications/AdminNotifications';
import AdminSettingsLayout from '../../screens/admin/AdminSettings/AdminSettingsLayout';
import AdminProfileSettings from '../../screens/admin/AdminSettings/AdminProfileSettings';
import AdminFaqsList from '../../components/admin/AdminSettings/AdminFaqList';
import AdminPasswordSettings from '../../screens/admin/AdminSettings/AdminPasswordSettings';
import AdminNotificationSettings from '../../screens/admin/AdminSettings/AdminNotificationSettings';
import AdminBlogs from '../../screens/admin/AdminBlogs/AdminBlogs';
import AdminHotelVendorManagement from '../../screens/admin/AdminPaymentAndBookingManagement/AdminHotelVendorManagement';
import AdminDestinationManagement from '../../screens/admin/AdminDestinationManagement/AdminDestinationManagement';
import CustomerDetailScreen from '../../screens/admin/AdminCustomerManagement/CustomerDetailScreen';
import AdminReviewsManagement from '../../screens/admin/AdminReviewsManagement/AdminReviewsManagement';
import PackageBookingDetails from '../../components/admin/AdminPackageManagement/PackageBookingDetails';
import PackageManagement from '../../screens/admin/AdminPackagesManagement/PackageManagementt';
import AdmSupportsTickets from '../../screens/admin/AdminTicketManagemen/AdmSupportsTickets';
import ScrollToTop from '../../components/general/ScrollToTop';

const AdminDashboardRoutes = () => {
  return (
    <> <ScrollToTop />
    <Routes>
     
      <Route path="" element={<DashboardLayout />}>
        <Route index element={<Navigate to="dashboard" replace />} />

        <Route path="dashboard" element={<DashboardHome />} />

        <Route path="users">
          <Route path="customers" element={<AdminUserManagement />} />
          <Route path="vendors"   element={<AdminUserManagement />} />
          <Route path="admins"    element={<AdminUserManagement />} />
          <Route path="customers/:id" element={<CustomerDetailScreen />} />
          <Route path="admins/:id"  element={<AdminDetailScreen />} />
        </Route>

        <Route path="vendors/all" element={<Navigate to="/admin/users/vendors" replace />} />

        <Route path="packages" element={<PackageManagement />}>
         <Route index element={<PackageDashboard />} />
         <Route path="pack-dashboard" element={<PackageDashboard />} />
         <Route path="list" element={<PackageList />} />
         <Route path="bookings" element={<PackageBookings />} />
         <Route path="package-bookings/:id" element={<PackageBookingDetails />} />
         <Route path="revenue" element={<PackageRevenue />} />
         <Route path="analytics" element={<PackageAnalytics />} />
         </Route>
        <Route
          path="/vendor-booking-management/*"
          element={
  
              <AdminHotelVendorManagement />
            
          }
        />

        <Route path="/reviews" element={<AdminReviewsManagement/>} />
        <Route path="notifications"    element={<AdminNotifications />} />
        <Route path="/blogs"           element={<AdminBlogs />} />
        <Route path="/settings" element={<AdminSettingsLayout />}>
        <Route index element={<Navigate to="profile" replace />} />
        <Route path="profile"       element={<AdminProfileSettings />} />
        <Route path="password"      element={<AdminPasswordSettings />} />
        <Route path="notifications" element={<AdminNotificationSettings />} />
        </Route>

        <Route path="support-tickets" element={<AdmSupportsTickets />} />
        <Route path="/support/faq" element={<AdminFaqsList />} />
        <Route path="/destinations"   element={<AdminDestinationManagement />} />
        /admin/support/faq
        <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
      </Route>
    </Routes>
    </>
  );
};

export default AdminDashboardRoutes;